import React from "react";

import workPassportReadinessJourneyDeploymentFlowDesktop from "../../images/work-passport-readiness-journey-deployment-flow-desktop.svg";
import workPassportReadinessJourneyDeploymentFlowMobile from "../../images/work-passport-readiness-journey-deployment-flow-mobile.svg";

import "./WorkPassportReadinessJourney.css";

const WORK_PASSPORT_READINESS_RESULTS = [
  { label: "Configured requirements", tone: "configured" },
  { label: "Evaluated evidence", tone: "evaluated" },
  { label: "Verified result", tone: "verified" },
];

export default function WorkPassportReadinessJourney() {
  return (
    <section
      className="work-passport-readiness-journey"
      id="work-passport-readiness-journey"
      aria-labelledby="work-passport-readiness-journey-title"
    >
      <div className="work-passport-readiness-journey__inner">
        <header className="work-passport-readiness-journey__header">
          <p className="work-passport-readiness-journey__eyebrow">
            <span aria-hidden="true" />
            From allocation to readiness
          </p>
          <div className="work-passport-readiness-journey__heading-grid">
            <h2 id="work-passport-readiness-journey-title">
              From allocation to verified readiness.
            </h2>
            <p>
              Configure the work. Allocate the workforce. Evaluate the
              evidence. Resolve the gap. Issue the digital Work Passport.
            </p>
          </div>
        </header>

        <picture className="work-passport-readiness-journey__visual">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportReadinessJourneyDeploymentFlowMobile}
          />
          <img
            src={workPassportReadinessJourneyDeploymentFlowDesktop}
            alt="Six-stage journey from configuring a site to issuing a verified Work Passport"
          />
        </picture>

        <ul className="work-passport-readiness-journey__results">
          {WORK_PASSPORT_READINESS_RESULTS.map((item) => (
            <li
              key={item.label}
              className={`work-passport-readiness-journey__result work-passport-readiness-journey__result--${item.tone}`}
            >
              <i aria-hidden="true" />
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
